import React from 'react'

class Quiz extends React.Component{
	constructor(props){
        super(props)

		this.state = {
        }
    }

    render(){
        var status = "lose"
        console.log(this.props.infos)
        if(Math.floor(this.props.infos.n/3.7) >= this.props.infos.mN){
            status = "win"
        }
        
        var description = []
        var title = []
        title["win"] = "Félicitations"
        title["lose"] = "Malheursuement"
        description['win'] = "vous avez réussi avec "+this.props.infos.mN+" fautes"
        description['lose'] = "vous n'avez pas réussi le test ( "+this.props.infos.mN+" fautes)"

        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4 containBorder">
                        <div className="hero-unit">
                        <h1 className="bienvenue">{ title[status] }</h1>
                            <img src={"./assets/"+status+".gif"} className="img-fluid" alt="best cat" />
                            <p className="Align">{description[status]}</p>
                            <p>
                                <div className="Align">
                                   <button type="button" onClick={() => window.location.reload()} className="btn btn-outline-success startBtn">Recommencer</button>
                                </div>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4"></div>
            </div>
        )
    }
    
}
export default Quiz


// WEBPACK FOOTER //
// ./src/components/end.js